/**
 * Banner Info Item used by the home banner
 */
export class BannerInfoItem {
  constructor(
    public id: string,
    public title: string,
    public description: string,
    public cta: string,
    public route: string,
    public imageUrl: string
  ) {}
}
